import { CountUp } from 'countup.js';
import { isScrolledIntoView } from '../helpers';

export default () => {
  let animated = false;

  const paragraph = document.querySelector('.paragraph--type--stats');

  function counter() {
    if (!animated && isScrolledIntoView(paragraph)) {
      const counters = paragraph.querySelectorAll('.stats-item__value');
      counters.forEach(element => {
        const options = {
          duration: 4,
        };
        const endVal = element.getAttribute('data-count-to') * 1;
        if (!(endVal % 1 === 0)) {
          options.decimalPlaces = 2;
        }

        const countUp = new CountUp(element, endVal, options);
        countUp.start();
      });
      animated = true;
    }
  }

  window.addEventListener('scroll', function() {
    if (paragraph) {
      counter();
    }
  });
};
